import React from "react";
import DataGrid from "../../../../dataGrid/index";
import TrailersGridConfig from "./GridConfig";
import { withUserProfile } from "../../../../../userProfile/userProfileContext";
import { compose } from "recompose";
import { withSnackbar } from "notistack";
import { withStyles } from "@material-ui/core/styles";
import styles from "./styles";
import StatusBar from "../../../../dataGrid/StatusBar";
import { getFilteredData } from "../../../../common/filterUtilities";
import appConstants from "../../../../../appConstants";
import { withTrailerHOC } from "../../Common/withTrailerHOC";

class TrailersGrid extends React.Component {
  constructor(props) {
    super(props);
    this.gridConfig = new TrailersGridConfig(
      this.props.userData.userProfile?.columnPref
    );
    this.gridHeaderId = `gridHeader_${this.props.glContainer._config.id}`;
    this.gridApi = {};
    this.state = {
      searchText: "",
      quickFilter: appConstants.EMPTY_STRING,
    };
  }
  componentDidMount() {
    this.props.glEventHub.on(this.gridHeaderId, this.onSearchTextChanged);
    this.props.glEventHub.on(
      "UpdateDispatchTrailerQuickFilter",
      this.updatedQuickFilter
    );
  }
  componentWillUnmount() {
    this.props.glEventHub.off(this.gridHeaderId, this.onSearchTextChanged);
    this.props.glEventHub.off(
      "UpdateDispatchTrailerQuickFilter",
      this.updatedQuickFilter
    );
  }
  onGridReady = ({ api }) => {
    this.gridApi = api;
  };
  onSearchTextChanged = (searchText) => {
    this.setState({
      searchText,
    });
  };

  updatedQuickFilter = (quickFilter) => {
    this.setState({
      quickFilter,
    });
  };
  constructStatusBar = (filteredData) => {
    return [
      {
        label: filteredData.length + " Trailers",
        filterCondition: "",
      },
    ];
  };

  getFilteredTrailers = () => {
    if (!this.props.trailerList || !this.state.quickFilter) {
      return this.props.trailerList;
    }
    return getFilteredData(this.props.trailerList, this.state.quickFilter);
  };

  render() {
    const trailersList = this.getFilteredTrailers();
    return (
      <React.Fragment>
        <div className={this.props.classes.dataGrid}>
          <DataGrid
            defaultColDef={this.gridConfig.config.defaultColDef}
            columnDefs={this.gridConfig.config.columns}
            columnTypes={this.gridConfig.config.columnTypes}
            config={this.gridConfig.config}
            rowSelection={this.gridConfig.config.rowSelection}
            rowDeselection={this.gridConfig.config.rowDeselection}
            rowData={trailersList}
            onGridReady={this.onGridReady}
            deltaRowDataMode={true}
            getRowNodeId={(data) => data.trailerId}
            panelLabel={(filteredData) => (
              <StatusBar data={this.constructStatusBar(filteredData)} />
            )}
            isExternalFilterPresent={true}
            layoutContainer={this.props.glContainer}
            quickFilterText={this.state.searchText}
            showErrorMessage={this.props.trailerDataMessage}
          />
        </div>
      </React.Fragment>
    );
  }
}
export default compose(
  withUserProfile,
  withSnackbar,
  withStyles(styles)
)(withTrailerHOC(TrailersGrid));
